module.exports = [{
      plugin: require('/root/page/src/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/root/page/src/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
